// extracted by mini-css-extract-plugin
module.exports = {"PlaylistSongs":"PlaylistSongs_PlaylistSongs__3DKuY","PageNavigation":"PlaylistSongs_PageNavigation__1faAf","Prev":"PlaylistSongs_Prev__1amvk","Next":"PlaylistSongs_Next__3hawq"};